export const isSelectQuery = (query: string): boolean => {
  return /^select\s+/i.test(query.trim());
};
